<template>
  <el-dialog :visible.sync="viewManager.visible" width="600px" title="报价" append-to-body>

    <el-form ref="offerForm" v-loading="viewManager.loading" class="quotation-formcon" :model="formParams" :rules="rules">
      <div class="form-line">
        <el-form-item prop="offerPrice" required>
          <el-input v-model="formParams.offerPrice" placeholder="请输入你的报价">
            <span slot="suffix">一口价</span>
          </el-input>
        </el-form-item>
      </div>
      <div class="con" v-html="platformTxt">
        <!--<p class="con-title">平台报价规则如下：</p>-->
        <!--<div class="con-box" >-->
        <!--<p>1.权利人的姓名(名称)、联系方式、地址、身份证扫揎件(自然人)、企业法人营业执照(单位)、法定代表人身份证明(单位</p>-->
        <!--<p>2.要求删除或者断开链接的侵权作品的淮确名称和网络地址,以便干图网能够发现并初步审核涉嫌侵权作品。</p>-->
        <!--<p>3.认为构成侵权的初步证明材料,包括但不限于对作品享有版权或依法享有信息网络传播权的权属证明,以及涉嫌侵权作品侵权事实的举证。</p>-->
        <!--<p>4.通知书需由权利人或其合法授权人亲笔签名,若为单位则需加盖单位公章</p>-->
        <!--</div>-->
      </div>
      <el-checkbox v-model="checkedRule">我同意以上规则</el-checkbox>
      <div class="form-line">
        <el-form-item>
          <el-button class="quotation-form-btn quotation-btn" :class="{'quotation-btn-xz': !checkedRule}" @click="updateExpectPrice">报价</el-button>
        </el-form-item>
        <!--<el-form-item>-->
        <!--<el-button class="quotation-form-btn" @click="viewManager.close">取消</el-button>-->
        <!--</el-form-item>-->
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
import mixinsFunction from '@/utils/mixinsFunction'
import { updateExpectPrice, findCmsPlatformProtocol } from '@/api/personal/find/goodsManager'
import { validateNumber } from '@/views/personal/goods/dataConfig/rules.js'
export default {
  name: 'Offer',
  mixins: [mixinsFunction],
  data: function() {
    return {
      // 是否同意规则
      // 平台规则弹窗状态
      platform: false,
      // 是否同意规则
      checkedRule: false,
      // 是否不再提示平台规则
      checkedRemind: false,
      platformTxt: '',
      rules: {
        offerPrice: [
          { required: true, message: '必填' },
          { validator: validateNumber, trigger: 'blur' }
        ]
      },
      formParams: {
        goodsId: '',
        offerPrice: 0,
        goodsCreateUser: '',
        companyId: '',
        transportId: ''
      }
    }
  },
  created() {
    const con = {
      type: 2,
      location: 1
    }
    findCmsPlatformProtocol(con).then(res => {
      console.log(res)
      if (res.result.length < 1) {
        this.dealManager.visible = true
      } else {
        this.platform = true
        this.platformTxt = res.result[0].content
      }
    })
  },
  methods: {

    // 报价
    open(item, transportId) {
      this.isDetificate().then(() => {
        this.cleanModal(this.formParams)
        this.formParams.goodsId = item.id
        this.formParams.transportId = transportId
        this.formParams.goodsCreateUser = item.createUser
        this.formParams.companyId = item.companyId
        this.formParams.weight = item.weight
        this.formParams.goodsTypeLabel = item.goodsTypeLabel
        this.formParams.companyName = item.companyName
        this.formParams.companyContact = item.contacter
        this.formParams.contactTel = item.contacterTel
        this.viewManager.visible = true
        this.viewManager.loading = false
      })
    },
    // 发起报价请求
    updateExpectPrice() {
      if (this.checkedRule) {
        this.$refs['offerForm'].validate(valid => {
          if (valid) {
            // 发起报价请求
            this.viewManager.loading = true
            updateExpectPrice(this.formParams).then(data => {
              this.$message({
                message: '报价成功',
                type: 'success'
              })
              this.$emit('done')
              setTimeout(() => {
                this.viewManager.close()
              }, 500)
            }).catch(error => {
              console.error(error)
            })
          } else {
            return false
          }
        })
      } else {
        this.$message({
          message: '未同意以上规则！',
          type: 'warning'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-form.quotation-formcon {
  position: relative;
}
/deep/.el-form-item__content{
  text-align: center;
  margin-top: 10px;
}
  .con{
    position: relative;
    margin-bottom: 10px;
    margin-top: 10px;
    padding: 5px 0px;
    border-bottom: 1px solid #E3E3E3;
    .con-title{
      padding-bottom: 10px;
      color: #F92929;
    }
    .con-box{
      p{
        padding-bottom: 8px;
        line-height: 18px;
      }
    }
  }
  .quotation-btn{
    border-radius: 5px;
    background: #BF2317;
    color: #fff;
    &.quotation-btn-xz{
      background: #DE9189;
      color: #F2CCC3;
    }
  }
</style>

